import React from "react";
import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Button from '../UI/Button';
import Loading from '../Loading';
import TextInput from '../UI/TextInput';
import PasswordInput from '../UI/PasswordInput';
import EmailInput from "../UI/EmailInput";
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ReactComponent as TooltipIcon } from '../../assets/icons/tooltip.svg';

const SignUpForm = ({ onSubmit, loading }) => {
  const { register, handleSubmit, errors } = useForm();

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col lg={6}>
            <fieldset>
              <label htmlFor="username">Username <span>*</span></label>
              <div className="tooltip-container">
                <TextInput 
                  name="username"
                  type="text"
                  register={register({ required: true })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      Username should only contain letters, numbers, underscores or periods.  This can be something like the company name, or your full name.
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors.username && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <fieldset>
              <label htmlFor="password">Password <span>*</span></label>
              <div className="tooltip-container">
                <PasswordInput 
                  regitration={false}
                  name="password"
                  type="password"
                  register={register({ 
                    required: "You must specify a password", 
                    minLength: {
                      value: 8,
                      message: "Password must have at least 8 characters"
                    }
                  })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      Write your password down for later use.
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors.password && errors.password.type === "required" &&
                <p className="warnMessage">This field is required</p>
              }
              {errors.password && errors.password.type === "minLength" && 
                <p className="warnMessage">The password is too short</p>
              }
            </fieldset>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <fieldset>
              <label htmlFor="email">Email address <span>*</span></label>
              <div className="tooltip-container">
                <EmailInput 
                  name="email"
                  type="email"
                  register={register({ required: true })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      A valid email address: joe@gmail.com  This will be the primary email address for your account.
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors.email && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button 
              type="submit"
              width="py-3 mt-5"
              label="Continue"
            />
          </Col>
        </Row>
      </form>
      {loading && <Loading />}
    </>
  );
};

export default SignUpForm;